import Model from './media/Model';
import VideoPlayer from './media/VideoPlayer';

/**
 * @class Media
 * @classdesc Several media utility functions for use across the theme.
 */
class Media {
  /**
   * Creates a new VideoPlayer
   */
  createVideo(el, host) {
    return new VideoPlayer(el, host);
  }

  createModel(el) {
    return new Model(el);
  }

  /**
   * Pauses all media.
   * Components with media should react to this event and pause associated media
   */
  pauseAll(exclude) {
    const event = new CustomEvent('core:pause-media', { detail: { exclude } });

    document.body.dispatchEvent(event);
  }
}

export default new Media();
